// extracted by mini-css-extract-plugin
export var subtitle = "_a7-2";
export var title = "_a7-0";
export var titleNoWrap = "_a7-1";